import * as $runtime from "../runtime.js";
import * as Data$dTuple$dT2 from "../Data.Tuple.T2/index.js";
import * as Record$dBuilder from "../Record.Builder/index.js";
import * as Record$dUnsafe from "../Record.Unsafe/index.js";
import * as Restaumatic$dForm$dDynamicResult from "../Restaumatic.Form.DynamicResult/index.js";
import * as Restaumatic$dForm$dFinal from "../Restaumatic.Form.Final/index.js";
import * as Restaumatic$dForm$dInternal from "../Restaumatic.Form.Internal/index.js";
import * as Restaumatic$dForm$dResult from "../Restaumatic.Form.Result/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFormField from "../Specular.FormField/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
const $Strictness = tag => ({tag});
const identity = x => x;
const Strict = /* #__PURE__ */ $Strictness("Strict");
const Lax = /* #__PURE__ */ $Strictness("Lax");
const queryUnitRecordTotal = dictTypeEquals => ({queryImpl: v => v1 => Restaumatic$dForm$dDynamicResult.applicativeDynamicResult.pure()});
const queryRefTotal = dictTypeEquals => {
  const to = dictTypeEquals.proof(a => a);
  return {queryImpl: v => x => Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.applicativeResult.pure)(Specular$dFRP$dBase.functorDynamic.map(to)(x._1))};
};
const queryRecordNilTotal = {queryRecordImpl: v => v1 => v2 => Restaumatic$dForm$dDynamicResult.applicativeDynamicResult.pure(identity)};
const queryFinalPartial = dictTypeEquals => {
  const to = dictTypeEquals.proof(a => a);
  return {
    queryImpl: v => x => Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.functorResult.map(to))(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.liftV)(x))
  };
};
const queryDynamicTotal = dictTypeEquals => {
  const to = dictTypeEquals.proof(a => a);
  return {queryImpl: v => x => Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.applicativeResult.pure)(Specular$dFRP$dBase.functorDynamic.map(to)(x))};
};
const eqStrictness = {
  eq: x => y => {
    if (x.tag === "Strict") { return y.tag === "Strict"; }
    if (x.tag === "Lax") { return y.tag === "Lax"; }
    return false;
  }
};
const queryRecordImpl = dict => dict.queryRecordImpl;
const queryRecord = dictAsRecord => () => dictQueryRecord => (
  {
    queryImpl: s => f => Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.functorResult.map(x => dictAsRecord.fromRecord(x({}))))(dictQueryRecord.queryRecordImpl(s)(Type$dProxy.Proxy)(f))
  }
);
const queryImpl = dict => dict.queryImpl;
const queryWith = dictQuery => v => {
  if (v.tag === "Lax") {
    const $0 = dictQuery.queryImpl(Lax);
    return x => Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.toLax)($0(x));
  }
  if (v.tag === "Strict") {
    const $0 = dictQuery.queryImpl(Strict);
    return x => Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.toStrict)($0(x));
  }
  $runtime.fail();
};
const queryLax = dictQuery => queryWith(dictQuery)(Lax);
const queryLaxWithDefault = dictQuery => def => {
  const $0 = Restaumatic$dForm$dInternal.unFinalWithDefault(def);
  const $1 = queryWith(dictQuery)(Lax);
  return x => $0($1(x));
};
const queryFormFieldPartial = dictTypeEquals => {
  const queryImpl1 = queryFinalPartial(dictTypeEquals).queryImpl;
  return {
    queryImpl: s => {
      const $0 = queryImpl1(s);
      return x => $0(Restaumatic$dForm$dFinal.makeFinal(Specular$dFRP$dBase.functorDynamic.map(Specular$dFormField.fromValidV)(x.finalValue)));
    }
  };
};
const queryRecordCons = dictIsSymbol => dictQueryRecord => dictQuery => () => () => () => () => () => (
  {
    queryRecordImpl: s => v => f => Restaumatic$dForm$dDynamicResult.applyDynamicResult.apply(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.functorResult.map(v1 => v2 => x => Record$dBuilder.unsafeInsert(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(v1)(v2(x))))(dictQuery.queryImpl(s)(Record$dUnsafe.unsafeGet(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(f))))(dictQueryRecord.queryRecordImpl(s)(Type$dProxy.Proxy)(f))
  }
);
const queryT2T2 = dictQuery => dictQuery1 => () => (
  {
    queryImpl: s => v => Restaumatic$dForm$dDynamicResult.applyDynamicResult.apply(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.functorResult.map(Data$dTuple$dT2.T2))(dictQuery.queryImpl(s)(v._1)))(dictQuery1.queryImpl(s)(v._2))
  }
);
const query = dictQuery => queryWith(dictQuery)(Strict);
export {
  $Strictness,
  Lax,
  Strict,
  eqStrictness,
  identity,
  query,
  queryDynamicTotal,
  queryFinalPartial,
  queryFormFieldPartial,
  queryImpl,
  queryLax,
  queryLaxWithDefault,
  queryRecord,
  queryRecordCons,
  queryRecordImpl,
  queryRecordNilTotal,
  queryRefTotal,
  queryT2T2,
  queryUnitRecordTotal,
  queryWith
};
